import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";

/** Compact clickable table header cell used across the Officers list view. */
export function SortableHeader({ k, sortKey, sortDir, onSort, align = "left", children }) {
  const active = sortKey === k;
  return (
    <th className={`px-4 py-3 ${align === "right" ? "text-right" : "text-left"}`}>
      <button
        type="button"
        data-testid={`sort-${k}`}
        onClick={() => onSort(k)}
        className={`inline-flex items-center gap-1 label-mute hover:text-white transition-colors ${active ? "text-[#FF3B30]" : ""}`}
      >
        {children}
        {active
          ? (sortDir === "asc" ? <ArrowUp className="size-3" /> : <ArrowDown className="size-3" />)
          : <ArrowUpDown className="size-3 opacity-40" />}
      </button>
    </th>
  );
}
